export default __webpack_public_path__ + "static/media/seat-rounded-front.fb3723f3.webp";